import { Route, Switch } from "react-router-dom";
import ipConfig from "./ipConfig.json";
import Products from "./components/Products";
import Register from "./components/Register";
import Login from "./components/Login";
import Checkout from './components/Checkout'
import Thanks from './components/Thanks'


export const config = {
  endpoint: `https://qkart-frontend-cl9u.onrender.com/api/v1`,
};
      
function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/"  > <Products /> </Route>
        <Route path="/register"> <Register /> </Route>
        <Route path="/login"   > <Login />    </Route>
        <Route path="/checkout"> <Checkout /> </Route>
        <Route path="/thanks"> <Thanks /> </Route>
      </Switch>
    </div>
  )
}

export default App


        
